import React from 'react'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
// import styles from '../AskAboutPropertyForm/styles.module.sass'
import FormControl from 'react-bootstrap/FormControl'

const FileInput = ({
  values,
  handleChange,
  touched,
  errors,
  label,
  placeholder,
  formName,
  multiple,
  ...rest
}) => {
  return (
    <Form.Group as={Col} xs="12" controlId="name">
      <Form.Label>{label}</Form.Label>
      <FormControl
        placeholder={placeholder}
        type="file"
        name={formName}
        value={values[formName]}
        onChange={handleChange}
        isValid={touched[formName] && !errors[formName]}
        multiple={multiple}
        {...rest}
      />
    </Form.Group>
  )
}
export default FileInput
